interface FuelTypeToggleProps {
  value: 'E10' | 'B7'
  onChange: (value: 'E10' | 'B7') => void
}

/**
 * Two-option toggle for selecting fuel type (Petrol E10 or Diesel B7)
 * Designed to be sticky in header per PROJECT.md
 */
export function FuelTypeToggle({ value, onChange }: FuelTypeToggleProps) {
  return (
    <div className="flex bg-slate-200 dark:bg-slate-700 rounded-lg p-1">
      <button
        onClick={() => onChange('E10')}
        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
          value === 'E10'
            ? 'bg-green-500 text-white shadow-sm'
            : 'text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white'
        }`}
        aria-pressed={value === 'E10'}
      >
        Petrol
      </button>
      <button
        onClick={() => onChange('B7')}
        className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
          value === 'B7'
            ? 'bg-green-500 text-white shadow-sm'
            : 'text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white'
        }`}
        aria-pressed={value === 'B7'}
      >
        Diesel
      </button>
    </div>
  )
}
